import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Button from 'react-bootstrap/lib/Button';

import t from '../../lib/I18n';
import config from '../../config';

import Icon from '../general/Icon';

export default function SearchExpander ({ onExpand, isSearching, isExpanded, isDisabled }) {
    const expanderClassNames = classnames('input-group-btn expander', {
        'hidden': config.get('disableStationFinder'),
    });
    const buttonClick = isSearching ? null : onExpand;
    const buttonIcon = isSearching ? <Icon className="search-spin" icon="spinner" /> : isExpanded ? <Icon icon="close" /> : <Icon icon="search" />;
    const buttonLabel = isExpanded ? t('stationFinder.shrink.buttonLabel') : t('stationFinder.expand.buttonLabel');

    return (
        <span className={ expanderClassNames }>
            <Button
                onClick={ buttonClick }
                disabled={ isDisabled }
                bsStyle="primary"
                aria-expanded={ Boolean(isExpanded) }
                aria-controls="stationFinder-overlay"
                aria-label={ buttonLabel }
            >
                { buttonIcon }
            </Button>
        </span>
    );
}

SearchExpander.propTypes = {
    onExpand: PropTypes.func.isRequired,
    isSearching: PropTypes.bool,
    isExpanded: PropTypes.bool,
    isDisabled: PropTypes.bool,
};

SearchExpander.defaultProps = {
    isSearching: false,
    isExpanded: false,
};



// WEBPACK FOOTER //
// ./src/components/stationFinder/SearchExpander.js